import { render } from "./DiretorioListFiltroDialog.vue?vue&type=template&id=621b9de8"
import script from "./DiretorioListFiltroDialog.vue?vue&type=script&lang=js"
export * from "./DiretorioListFiltroDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__